import { Component, OnDestroy, OnInit, inject, input } from '@angular/core';
import {Subscription} from "rxjs";
import {ChipModule} from "primeng/chip";
import {ButtonModule} from "primeng/button";
import {RippleModule} from "primeng/ripple";
import {DataView, DataViewModule} from "primeng/dataview";
import {SelectModule} from "primeng/select";
import {InputTextModule} from "primeng/inputtext";
import {RatingModule} from "primeng/rating";
import {SelectItem} from "primeng/api";
import {DataService} from "../../../service/data.service";
import { SlicePipe } from "@angular/common";
import {DialogModule} from "primeng/dialog";
import {ProjectDescriptorUse, WriterStatus} from "../../../api/enums";
import {ProjectDetailComponent} from "../../project-display/project-detail/project-detail.component";
import {ProjectDisplayComponent} from "../../project-display/project-display.component";
import {BetaReaderProfile} from "../../../api/db/entities/BetaReaderProfile";
import {BetaReaderProject} from "../../../api/db/entities/BetaReaderProject";
import {Project} from "../../../api/db/entities/Project";
import { PlatformUser } from '../../../api/db/entities/PlatformUser';
import { ProjectProfileGroup } from 'src/app/api/db/entities/ProjectProfileGroup';
import { ProjectMatchType } from 'src/app/api/db/entities/ProjectMatchType';

@Component({
    selector: 'beta-reader-project-matches',
    imports: [
    ChipModule,
    ButtonModule,
    RippleModule,
    DataViewModule,
    SelectModule,
    InputTextModule,
    RatingModule,
    DialogModule,
    ProjectDisplayComponent
],
    templateUrl: './beta-reader-project-matches.component.html',
    styleUrl: './beta-reader-project-matches.component.scss'
})
export class BetaReaderProjectMatchesComponent {
    private dataService = inject(DataService);
    protected user: PlatformUser = this.dataService.user();
    protected profileGroup: ProjectProfileGroup;


    readonly betaReader = input.required<BetaReaderProfile>();

    //projectMatches: Record<string, ProjectMatchType> = {};
    projectMatches: ProjectMatchType[] = [];
    sortOptions: SelectItem[] = [];
    sortOrder: number = 0;
    sortField: string = '';
    projectMatchesArray: { betaReaderProject: BetaReaderProject; project: Project }[] = [];
    

    constructor() {
        this.updateMatches();
    }

    onSortChange(event: any) {
        const value = event.value;

        if (value.indexOf('!') === 0) {
            this.sortOrder = -1;
            this.sortField = value.substring(1, value.length);
        } else {
            this.sortOrder = 1;
            this.sortField = value;
        }
    }

    onFilter(dv: DataView, event: Event) {
        dv.filter((event.target as HTMLInputElement).value);
    }

    protected readonly ProjectDescriptorUse = ProjectDescriptorUse;

    async updateMatches() {
        //TODO - get matches from dataService
        //Check projectMatchType object first as cache to see if it exists before querying

        //console.log(this.projectArray);

        this.profileGroup = this.user.betaReaderProfile.getProfileGroupForCode("FICTION_SERIES");
        //await this.dataService.matchProjectToReader(this.profileGroup);

        let tempArray = this.dataService.getMatchArray();

        for (let i = 0; i < tempArray.length; i++) {
            this.projectMatchesArray[i] = {betaReaderProject: null, project: tempArray[i]}
        }
        
        this.projectMatches = this.dataService.rMatchSignal();
        console.log(this.projectMatchesArray);
        console.log(this.projectMatches);
    }
}
